import { useState, useRef } from 'react'
import { User } from 'lucide-react'
import { ConfirmationDialog } from '@valiant/ui-shared'
import { ActionPopover } from './wrappers/ActionPopover'
import { ProfileContent } from './content/ProfileContent'

interface ProfilePopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onMobileClick?: () => void
  isActive?: boolean
}

export function ProfilePopover({
  open,
  onOpenChange,
  onMobileClick,
  isActive,
}: ProfilePopoverProps) {
  const [showResetPasswordDialog, setShowResetPasswordDialog] = useState(false)
  const [isResetting, setIsResetting] = useState(false)
  const confirmFnRef = useRef<(() => Promise<void>) | null>(null)

  const handleResetPasswordRequest = (confirmFn: () => Promise<void>) => {
    confirmFnRef.current = confirmFn
    setShowResetPasswordDialog(true)
  }

  const handleConfirmReset = async () => {
    if (!confirmFnRef.current) return
    setIsResetting(true)
    await confirmFnRef.current()
    setIsResetting(false)
    setShowResetPasswordDialog(false)
  }

  return (
    <>
      <ActionPopover
        open={open}
        onOpenChange={onOpenChange}
        trigger={<User className="w-8 h-8" />}
        onMobileClick={onMobileClick}
        isActive={isActive}
      >
        <ProfileContent
          onOpenChange={onOpenChange}
          onResetPasswordRequest={handleResetPasswordRequest}
        />
      </ActionPopover>

      <ConfirmationDialog
        open={showResetPasswordDialog}
        onOpenChange={setShowResetPasswordDialog}
        title="Reset Password"
        description="Are you sure you want to reset your password? A password reset email will be sent to your email address."
        confirmText="Reset Password"
        onConfirm={handleConfirmReset}
        isLoading={isResetting}
        variant="destructive"
      />
    </>
  )
}
